import { render, staticRenderFns } from "./back-stock-order-batch.vue?vue&type=template&id=a4ff6f76&scoped=true"
import script from "./back-stock-order-batch.vue?vue&type=script&lang=ts"
export * from "./back-stock-order-batch.vue?vue&type=script&lang=ts"
import style0 from "./back-stock-order-batch.vue?vue&type=style&index=0&id=a4ff6f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ff6f76",
  null
  
)

export default component.exports